/**
 * System Permission Definitions
 * EXACTLY matches the permissions defined in application_role_permissions table
 */

export const PERMISSIONS = {
    // Dashboard
    DASHBOARD_NAVIGATE: 'dashboard:navigate',

    // Settings
    SETTINGS_READ: 'settings:read',
    SETTINGS_UPDATE: 'settings:update',

    // Staff Demand Report
    STAFF_DEMAND_REPORT_READ: 'staff_demand_report:read',

    // Staff Pricing
    STAFF_PRICING_READ: 'staff_pricing:read',
    STAFF_PRICING_UPDATE: 'staff_pricing:update',

    // Price Items
    PRICE_ITEM_CREATE: 'price_item:create',
    PRICE_ITEM_READ: 'price_item:read',
    PRICE_ITEM_UPDATE: 'price_item:update',
    PRICE_ITEM_DELETE: 'price_item:delete',

    // Billing
    BILLING_READ: 'billing:read',
    // Legacy coarse permission — retained for older role grants. New code should
    // use BILLING_CONFIG_MANAGE, BILLING_SHEET_*, or BILLING_WORKSHEET_*.
    BILLING_MANAGE: 'billing:manage',
    // Configuration: billing groups, GL account masters, and sheet↔group↔GL assignments
    BILLING_CONFIG_MANAGE: 'billing:config_manage',
    // Billing sheet templates (name, care types, groups, default/sort)
    BILLING_SHEET_CREATE: 'billing_sheet:create',
    BILLING_SHEET_UPDATE: 'billing_sheet:update',
    BILLING_SHEET_DELETE: 'billing_sheet:delete',
    // Monthly worksheets generated from a sheet for a site + period
    BILLING_WORKSHEET_CREATE: 'billing_worksheet:create',
    BILLING_WORKSHEET_UPDATE: 'billing_worksheet:update',
    BILLING_WORKSHEET_ARCHIVE: 'billing_worksheet:archive',
    BILLING_WORKSHEET_REMOVE: 'billing_worksheet:remove',
    BILLING_WORKSHEET_DELETE: 'billing_worksheet:delete',

    // Activities
    ACTIVITY_READ: 'activity:read',
    ACTIVITY_UPDATE: 'activity:update',
    ACTIVITY_DELETE: 'activity:delete',

    // Quotations
    QUOTATION_CREATE: 'quotation:create',
    QUOTATION_READ: 'quotation:read',
    QUOTATION_UPDATE: 'quotation:update',
    QUOTATION_DELETE: 'quotation:delete',
    QUOTATION_VIEW_ARCHIVED: 'quotation:view_archived',
    QUOTATION_VIEW_REMOVED: 'quotation:view_removed',
    QUOTATION_ARCHIVE: 'quotation:archive',
    QUOTATION_RESTORE: 'quotation:restore',

    // Service Plans (Care Plans)
    SERVICE_PLAN_CREATE: 'service_plan:create',
    SERVICE_PLAN_READ: 'service_plan:read',
    SERVICE_PLAN_UPDATE: 'service_plan:update',
    SERVICE_PLAN_DELETE: 'service_plan:delete',
    SERVICE_PLAN_VIEW_ARCHIVED: 'service_plan:view_archived',
    SERVICE_PLAN_VIEW_REMOVED: 'service_plan:view_removed',
    SERVICE_PLAN_ARCHIVE: 'service_plan:archive',
    SERVICE_PLAN_RESTORE: 'service_plan:restore',

    // Assessments
    ASSESSMENT_CREATE: 'assessment:create',
    ASSESSMENT_READ: 'assessment:read',
    ASSESSMENT_UPDATE: 'assessment:update',
    ASSESSMENT_DELETE: 'assessment:delete',

    // Clients (Customers)
    CLIENT_CREATE: 'client:create',
    CLIENT_READ: 'client:read',
    CLIENT_UPDATE: 'client:update',
    CLIENT_DELETE: 'client:delete',
    CLIENT_VIEW_ARCHIVED: 'client:view_archived',
    CLIENT_ARCHIVE: 'client:archive'
};

export default PERMISSIONS;